// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../../config'
import { getHeaders, ApiScope } from '../../silentAuth'
import { BacnetPropertyMappingConfiguration, CreatePropertyMappingCommand } from './types'
import { BacnetObjectTypes } from './types'
import { cacher } from "../../rtkQueryCacheUtils";




// Define a service using a base URL and expected endpoints
export const bacnetPropertyMappingApi = createApi({
  reducerPath: 'bacnetPropertyMappingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.apiBaseUrl,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: [...cacher.defaultTags, 'BacnetPropertyMappings'],
  endpoints: (builder) => ({
    getPropertyMappingsFromObjectId: builder.query<BacnetPropertyMappingConfiguration[], string>({
      query: (objectid) => `/mappings/v2/propertyMappings?objectId=${objectid}`,
      providesTags: cacher.providesList('BacnetPropertyMappings'),
    }),
    getPropertyMappingsFromDevice: builder.query<BacnetPropertyMappingConfiguration[], { edgeDeviceId: string, bacnetDeviceId: number }>({
      query: ({ edgeDeviceId, bacnetDeviceId }) => `/mappings/v2/propertyMappings?edgedeviceId=${edgeDeviceId}&bacnetDeviceId=${bacnetDeviceId}`,
      providesTags: cacher.providesList('BacnetPropertyMappings'),
    }),
    createPropertyMapping: builder.mutation<BacnetPropertyMappingConfiguration, CreatePropertyMappingCommand>({
      query: (obj) => ({
        url: `/mappings/mappings/bacnetproperty/new`,
        method: 'post',
        body: obj
      }),
      invalidatesTags: cacher.invalidatesList("BacnetPropertyMappings")
    }),
    deletePropertyMapping: builder.mutation<string, string>({
      query: (id) => ({
        url: `/mappings/mappings/bacnetproperty/${id}`,
        method: 'delete',
      }),
      invalidatesTags: cacher.invalidatesList("BacnetPropertyMappings")
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPropertyMappingsFromObjectIdQuery,
  useCreatePropertyMappingMutation,
  useDeletePropertyMappingMutation,
  useGetPropertyMappingsFromDeviceQuery
} = bacnetPropertyMappingApi